import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { getPartnerTransactionCount } from '@apis/partner';

export const usePartnerTransactionCount = (partnerId: number) => {
  const queryOptions: UseQueryOptions<number, Error> = {
    // Total transaction count for pagination.
    queryKey: ['partnerTransactionsCount', partnerId],
    queryFn: () => getPartnerTransactionCount(partnerId),
    enabled: Boolean(partnerId),
  };

  return useQuery(queryOptions);
};
